
import Table from '@/components/common/Table.vue';
import Vue, { PropType } from 'vue';
import { BvTableFieldArray } from 'bootstrap-vue/src/components/table';
import { DeviceCalibration } from '@/interfaces/calibration';
import { Zone } from '@/interfaces/lighting';
import dayjs from '@/plugins/dayjs';

/*
	This section is picked up by vue-i18n. DO NOT REMOVE.

	// Status messages
	this.$t('Calibrated');
	this.$t('Started');
	this.$t('Scheduled');
	this.$t('No calibration');
	this.$t('Failed');
	this.$t('Canceled');
*/

interface CalibrationTableRow {
	id: number;
	idGroup: number;
	zoneName: string;
	start: string;
	end: string;
	status: string;
	progress: string;
	zoneCalibrate: string;
	zoneCalibratePermission: boolean;
}

export default Vue.extend({
	components: {
		Table,
	},

	props: {
		calibrations: {
			type: Array as PropType<DeviceCalibration[]>,
			default: (): DeviceCalibration[] => [],
		},
		zones: {
			type: Array as PropType<Zone[]>,
			default: (): Zone[] => [],
		},
		userReadPermission: { type: Boolean, default: true },
		userWritePermission: { type: Boolean, default: true },
	},

	computed: {
		fields(): BvTableFieldArray {
			return [
				{ key: 'zoneName', label: this.$t('Zone name').toString(), sortable: true },
				{ key: 'outdoor', label: this.$t('Outdoor').toString(), sortable: true },
				{ key: 'start', label: this.$t('Start').toString(), sortable: true },
				{ key: 'end', label: this.$t('End').toString(), sortable: true },
				{ key: 'status', label: this.$t('Calibration status').toString(), sortable: true },
				{ key: 'progress', label: this.$t('Progress').toString(), sortable: false },
				{ key: 'zoneCalibrate', label: '', sortable: false },
			];
		},

		calibrationRows(): CalibrationTableRow[] {
			return this.calibrations.map((calibration) => {
				return {
					id: calibration.id,
					idGroup: calibration.fk_group,
					zoneName: this.zones.find((zone) => zone.id === calibration.fk_group)?.name ?? '-',
					outdoor: calibration.outdoor
						? this.$t('Enabled').toString()
						: this.$t('Not enabled').toString(),
					start: calibration?.dt_start ? dayjs(calibration.dt_start).format('lll') : '-',
					end: calibration?.dt_end ? dayjs(calibration.dt_end).format('lll') : '-',
					status: calibration?.status ? this.$t(calibration.status).toString() : '-',
					progress: calibration?.progress ? `${calibration.progress}%` : '-',
					zoneCalibrate: calibration.status,
					zoneCalibratePermission: this.userWritePermission,
				};
			});
		},
	},

	methods: {
		changeZoneCalibration(
			row: CalibrationTableRow,
			selectedDate: string,
			daylightMode: boolean,
			lightLevel: number
		): void {
			this.$emit(
				'changeZoneCalibration',
				selectedDate,
				daylightMode,
				lightLevel,
				row.id,
				row.zoneCalibrate
			);
		},
	},
});
